import {useEffect, useState, useRef } from "react";

function VoiceIndicator({ size, bgColor }) {
    const range = Array.from({ length: 3 }, (_, index) => index + 1);
    return <div className="flex flex-row gap-2">
            {range.map((key) => (
                <div
                    key={key}
                    className="rounded-full transition-all"
                    style={{ width: size, height: size, backgroundColor: bgColor }}
                ></div>
            ))}
    </div>

}

export default function ReadingAnswer({
                                      botReply,
                                      base64AudioSourceData,
                                      onEnded,
                                        stop=false,
                                          minimiz=false
                                  }) {
    const [audioSource, setAudioSource] = useState();
    const analyserRef = useRef(null);
    const mediaElementSource = useRef(null);
    let animationFrameId = useRef(null);

    const [readerVoiceIndicatorSize, setReaderVoiceIndicator] = useState(50); // Default size
    const [readerVoiceIndicatorBgColor, setReaderVoiceIndicatorBgColor] = useState('gray'); // Default color

    // TODO fix later
    const updateReadingVoiceIndicator = () => {
        if (!analyserRef.current) {
            return;
        }

        const userVolumeScaleDataArray = new Uint8Array(analyserRef.current.frequencyBinCount);
        analyserRef.current.getByteTimeDomainData(userVolumeScaleDataArray);
        const volume = Math.max(...userVolumeScaleDataArray); // Simplified volume calculation

        setReaderVoiceIndicator(volume + -80); // Update size based on volume
        const grayValue = Math.min(240, volume * 2);
        setReaderVoiceIndicatorBgColor(`rgb(${grayValue}, ${grayValue}, ${grayValue})`);

        requestAnimationFrame(updateReadingVoiceIndicator);
    };

    // TODO fix later
    const handleAudio = async () => {
        if (!mediaElementSource.current) {
            const audioContext = new AudioContext();
            analyserRef.current = audioContext.createAnalyser();
            const audioElement = document.getElementById('readingAudio');
            const source = audioContext.createMediaElementSource(audioElement);
            source.connect(analyserRef.current);
            analyserRef.current.connect(audioContext.destination);
            mediaElementSource.current = source;
        }
        updateReadingVoiceIndicator();
    };

    const mimicVoiceIndicatorAnimation = () => {
        // Simple mimic animation logic
        const newSize = Math.random() * 50 + (minimiz? 20: 50); // Random size between 100 and 200
        const grayValue = Math.floor(Math.random() * 500);
        const newBgColor = `rgb(${grayValue}, ${grayValue}, ${grayValue})`;

        setReaderVoiceIndicator(newSize);
        setReaderVoiceIndicatorBgColor(newBgColor);

        animationFrameId.current = requestAnimationFrame(mimicVoiceIndicatorAnimation);
    };

    useEffect(() => {
        animationFrameId.current = requestAnimationFrame(mimicVoiceIndicatorAnimation);
        return ()=> {
            if (mediaElementSource.current) {
                mediaElementSource.current.disconnect();
                mediaElementSource.current = null;
            }

            if (analyserRef.current) {
                analyserRef.current.disconnect();
                analyserRef.current = null;
            }

            if (animationFrameId.current) {
                cancelAnimationFrame(animationFrameId.current);
            }
        }
    }, []);

    useEffect(() => {
        if (botReply && botReply.message && botReply.message.voiceMessage) {
            setAudioSource(botReply.message.voiceMessage)
        } else if (base64AudioSourceData) {
            setAudioSource(`data:audio/mpeg;base64,${base64AudioSourceData}`)
        }
    }, [botReply]);

    useEffect(() => {
        if (audioSource) {
            // TODO mimic animation until resolve issue
            // handleAudio()
        }
    }, [audioSource]);

    return (
        <div>
            {!stop && audioSource &&
                <div>
                    <audio id="readingAudio" hidden={true} controls autoPlay src={audioSource} onEnded={onEnded} />
                    {!minimiz &&
                        <VoiceIndicator size={readerVoiceIndicatorSize} bgColor={readerVoiceIndicatorBgColor} />
                    }
                </div>
            }

        </div>
    );
}